import { AttachmentUploader } from '@/shared/components/attachment-uploader'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { useGetAttachmentTypesQuery } from '@/store/services/attachment-type.service'
import { useCreateAttachmentMutation, useGetAttachmentsQuery, useUpdateAttachmentMutation } from '@/store/services/attachment.service'
import { Button, Dialog, DialogBody, DialogFooter, DialogHeader } from '@material-tailwind/react'
import { FiArrowLeft } from 'react-icons/fi'
import { createSearchParams, useLoaderData } from 'react-router-dom'
import { attachment as attachmentPath, list } from '@/router/utils'
import { useTranslation } from 'react-i18next'

export const CompanyAttachmentsUpload = () => {
  const { t } = useTranslation()
  const { company: currentCompany = {} } = useLoaderData()

  const attachmentSearchParams = createSearchParams({
    attachable_type: 'Contractor::Company',
    attachable_id: currentCompany.id,
    per_page: 9999,
    'sorter[field]': 'id',
    'sorter[order]': 'desc'
  })

  const attachmentTypeSearchParams = createSearchParams({
    klass: 'Contractor::Company',
    per_page: 9999,
    'service_area_ids[]': currentCompany.serviceAreas.map(serviceArea => serviceArea.id)
  })

  const { data: { attachmentTypes = [] } = {} } = useGetAttachmentTypesQuery(`?${attachmentTypeSearchParams}`)
  const { data: { attachments = [] } = {}, isLoading: isLoadingAttachments } = useGetAttachmentsQuery(`?${attachmentSearchParams}`)

  const [updateAttachment] = useUpdateAttachmentMutation()
  const [createAttachment] = useCreateAttachmentMutation()

  const onUpload = async (params) => {
    try {
      if (params?.id) {
        console.log('UPDATE')
        await updateAttachment(params).unwrap()
      } else {
        console.log('CREATE')
        await createAttachment({ ...params, attachable_id: currentCompany.id, attachable_type: 'Contractor::Company' }).unwrap()
      }
    } catch (error) {
      console.log(error)
      console.log('ERROR')
    }
  }

  return (
    <Dialog size='lg' open={true}>
      <DialogHeader className='pb-0'>
        <LinkWithQuery to={attachmentPath('companies', currentCompany.id)}>
          <Button
            size='sm'
            className='w-fit flex items-center'
            variant='text'
          >
            <FiArrowLeft size='16px' className='mr-2' />
            Volver
          </Button>
        </LinkWithQuery>
      </DialogHeader>

      <DialogBody>
        {
          !isLoadingAttachments &&
          <AttachmentUploader
            attachableType='Contractor::Company'
            attachmentTypes={attachmentTypes}
            showLatestAttachments
            attachments={attachments}
            onUpload={onUpload}
            restrictPastExpirationDates
            expirationDateNotice={t('common.uploadDocuments.pendingExpirationNotice', {
              entity: 'el contratista'
            })}
          >
            {(handleSubmit) => (

              <Button
                className='w-fit'
                variant='outlined'
                onClick={handleSubmit}
              >
                Agregar documento
              </Button>
            )}
          </AttachmentUploader>
        }
      </DialogBody>

      <DialogFooter>
        <LinkWithQuery to={list('companies')}>
          <Button
            variant='outlined'
            color='gray'
          >
            Salir
          </Button>
        </LinkWithQuery>
      </DialogFooter>
    </Dialog >
  )
}
